import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import RecentFiles from "./recentFiles";
import Files from "./files";
import { base_url } from "../../../base_urls";
import AiFileAnalysisSearchBar from "../../../components/MassAiSearchBar/SearchBar";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import ReusableInfoModal from "../../../components/modelpopup/ReusableInfoModal ";
import NotFreeModal from "../../../components/modelpopup/NotFreeModal";

const AiDataAnalysis = () => {
  const [filesvalues, setFilesValues] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [triggerUpload, setTriggerUpload] = useState(false);
  const [modaldata, setModaldata] = useState([]);
  const { fileSize, lastModified } = formatFileInfo(uploadedFile || "");
  const [fileValue, setFileValue] = useState("");

  const { t, i18n } = useTranslation();
  useEffect(() => {
    axios
      .get(base_url + "api/aiAnalysisSamples/aiFileSamples.json")
      .then((res) => setFilesValues(res.data))
      .catch((err) => console.log(err));
  }, []);

  const [resetSearch, setResetSearch] = useState(false);

  const handleResetChild = () => {
    setResetSearch(true);
    setUploadedFile(null);
    setTriggerUpload(false);
  };

  const handleFileUpload = (file) => {
    console.log("File received in parent:", file);
    setUploadedFile(file);
  };
  const triggerChildFileUpload = () => {
    setTriggerUpload(true);
    setTimeout(() => setTriggerUpload(false), 100); // Reset after trigger
  };

  const handlesidebar = () => {
    document.body.classList.toggle("file-sidebar-toggle");
  };
  useEffect(() => {
    if (resetSearch) {
      setResetSearch(false);
    }
  }, [resetSearch]);

  function formatFileInfo(file) {
    const sizeInKB = file.size / 1024;
    const readableSize =
      sizeInKB < 1024
        ? `${sizeInKB.toFixed(2)} KB`
        : `${(sizeInKB / 1024).toFixed(2)} MB`;

    const date = new Date(file.lastModified);
    const options = {
      day: "2-digit",
      month: "short",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const readableDate = date.toLocaleString("en-US", options); // Or use 'ar-EG', 'he-IL' etc. for localization

    return {
      fileSize: readableSize,
      lastModified: readableDate,
    };
  }
  const fintracKModalData = {
    modalId: "fintrackModal",
    title: "Fintrack: تحليل مالي ذكي بين يديك",
    sections: [
      {
        header: "أطلق العنان لقوة بياناتك المالية",
        content: (
          <p>
            هل سئمت من فحص جداول البيانات والتقارير المعقدة؟ Fintrack هو محللك
            المالي بالذكاء الاصطناعي، مصمم لتبسيط فهمك المالي، وتحديد الاتجاهات
            الرئيسية، وتقديم توصيات استراتيجية. من التقارير المالية المفصلة إلى
            الفواتير الفردية، نقوم بمعالجة كل شيء لنمنحك الوضوح والثقة.
          </p>
        ),
        isExpanded: true,
      },
      {
        header: "كيف يعمل Fintrack؟",
        content: (
          <ol>
            <li>
              <b>حمّل مستنداتك:</b> قم بتحميل أي مستند مالي بأمان - الميزانيات
              العمومية، بيانات الدخل، التدفقات النقدية، الفواتير، الإيصالات،
              والمزيد.
            </li>
            <li>
              <b>تحليل مدعوم بالذكاء الاصطناعي:</b> محرك Fintrack يحدد الأنماط
              والشذوذات والمؤشرات المالية المهمة.
            </li>
            <li>
              <b>رؤى ونصائح قابلة للتنفيذ:</b> تقارير مرئية ونصائح مخصصة تساعدك
              على اتخاذ قرارات مالية أفضل.
            </li>
          </ol>
        ),
        isExpanded: false,
      },
      {
        header: "لماذا تختار Fintrack؟",
        content: (
          <ul>
            <li>تحليل مالي شامل لرؤية واضحة ومتكاملة.</li>
            <li>أتمتة مدعومة بالذكاء الاصطناعي لتوفير الوقت والجهد.</li>
            <li>رؤى دقيقة تقلل من الخطأ البشري.</li>
            <li>توصيات قابلة للتنفيذ مخصصة لأهدافك.</li>
            <li>أمان عالي وحماية قوية لبياناتك.</li>
            <li>دعم لمجموعة واسعة من المستندات المالية.</li>
            <li>تقارير قابلة للتخصيص حسب احتياجاتك.</li>
          </ul>
        ),
        isExpanded: false,
      },
      {
        header: "Fintrack مصمم لك",
        content: (
          <ul>
            <li>
              <b>الشركات الصغيرة والمتوسطة:</b> تحكم أفضل في الربحية والنمو.
            </li>
            <li>
              <b>رواد الأعمال:</b> وضوح مالي يساعد في اتخاذ القرارات الذكية.
            </li>
            <li>
              <b>المستشارون والمحاسبون:</b> تحليل أسرع وأكثر دقة للعملاء.
            </li>
            <li>
              <b>الأفراد:</b> إدارة أفضل للاستثمارات والمصاريف الشخصية.
            </li>
          </ul>
        ),
        isExpanded: false,
      },
      {
        header: "آراء العملاء",
        content: (
          <ul>
            <li>
              "لقد غيّر Fintrack طريقة فهمي لأموال عملي. الرؤى قيمة وسهلة
              الفهم." - [الاسم]
            </li>
            <li>
              "يساعدني Fintrack في تقديم تحليلات أعمق لعملائي بسرعة." - [الاسم]
            </li>
          </ul>
        ),
        isExpanded: false,
      },
      {
        header: "ابدأ الآن",
        content: (
          <p>
            هل أنت مستعد لاكتساب وضوح لا مثيل له في شؤونك المالية؟{" "}
            <b>حمّل مستندك الأول - إنه مجاني!</b>
          </p>
        ),
        isExpanded: false,
      },
    ],
  };

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}

        <div className="content container-fluid">
          <div className="row">
            <div className="mb-4 pb-4 col-md-10 justify-content-center  ">
              <AiFileAnalysisSearchBar
                onFileUpload={handleFileUpload}
                triggerUpload={triggerUpload}
                reset={resetSearch}
                fileTypeObject={fileValue}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="file-wrap">
                <div className="file-cont-wrap w-100 me-0">
                  <div className="file-cont-inner">
                    <div className="file-cont-header">
                      <span className="text-primary">فحص البيانات الذكي </span>
                      <div className="">
                        <span className="btn-file">
                          <Link
                            to="#"
                            onClick={handleResetChild}
                            className="btn add-btn"
                          >
                            <i className="fa fa-add" /> فحص جديد
                          </Link>
                        </span>
                        <span className="btn-file">
                          <Link
                            to="#"
                            className="btn add-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#fintrackAIInfo"
                          >
                            <i className="fa fa-info" /> توضيح
                          </Link>
                        </span>
                      </div>
                    </div>
                    <div className="file-content">
                      <form className="file-search">
                        <div className="input-group">
                          <div className="input-group-text">
                            <i className="fa-solid fa-magnifying-glass" />
                          </div>
                          <input
                            type="text"
                            className="form-control rounded-pill"
                            placeholder="بحث"
                          />
                        </div>
                      </form>
                      <div className="file-body">
                        <div className="file-scroll">
                          <div className="file-content-inner">
                            {!uploadedFile && (
                              <>
                                <h3 className=" p-2 ">
                                  مستندات مالية قابلة للتحليل بواسطة
                                  <span className="text-primary">
                                    {" "}
                                    Mass Ai{" "}
                                  </span>
                                </h3>
                                <hr />
                                <div className="row row-sm justify-content-start ">
                                  {filesvalues.map((file, index) => (
                                    <div
                                      className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3"
                                      key={index}
                                    >
                                      <div className="card card-file">
                                        <div className="card-file-thumb text-primary">
                                          <i className={file.icon} />
                                        </div>
                                        <div className="card-body">
                                          <h6>
                                            <Link
                                              to="#"
                                              onClick={() => {
                                                setFileValue(file);
                                                triggerChildFileUpload();
                                              }}
                                              className="pb-2"
                                              data-tooltip-id="description-tooltip"
                                              data-tooltip-content={
                                                t(i18n.language) == "ar"
                                                  ? file.description_ar
                                                  : file.description_en
                                              }
                                            >
                                              {t(i18n.language) == "ar"
                                                ? file.reportName_ar
                                                : file.reportName_en}
                                            </Link>
                                          </h6>
                                          {/* <span>{file.fileSize}</span> */}
                                        </div>
                                        <div className="card-footer">
                                          <span className="d-none d-sm-inline">
                                            {/* Last Modified:{" "} */}
                                          </span>
                                          {/* {file.lastModified} */}
                                        </div>
                                      </div>
                                      <Tooltip
                                        id="description-tooltip"
                                        place="top"
                                        className="description-tooltip"
                                        // isOpen={true}
                                      />
                                    </div>
                                  ))}
                                </div>
                                <hr />
                              </>
                            )}
                            <h4 className="text-primary">
                              {uploadedFile
                                ? " الملف الحالي "
                                : "الملفات الحديثة"}{" "}
                            </h4>
                            {uploadedFile && (
                              <div className="row row-sm justify-content-start ">
                                <div className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3 mt-2">
                                  <div className="card card-file">
                                    <div className="dropdown-file">
                                      <Link
                                        to="#"
                                        className="dropdown-link  "
                                        data-bs-toggle="dropdown"
                                      >
                                        <i className="fa fa-ellipsis-v" />
                                      </Link>
                                      <div className="dropdown-menu dropdown-menu-right text-end">
                                        <Link to="#" className="dropdown-item">
                                          عرض التفاصيل
                                        </Link>
                                        <Link to="#" className="dropdown-item">
                                          مشاركة
                                        </Link>
                                        <Link to="#" className="dropdown-item">
                                          تحميل
                                        </Link>
                                        <Link to="#" className="dropdown-item">
                                          إعادة تسمية
                                        </Link>
                                        <Link to="#" className="dropdown-item">
                                          حذف
                                        </Link>
                                      </div>
                                    </div>
                                    <div className="card-file-thumb text-primary">
                                      <i
                                        className={`${
                                          uploadedFile.name.match(/\.(pdf)$/i)
                                            ? "fa-regular fa-file-pdf"
                                            : uploadedFile.name.match(
                                                /\.(doc|docx)$/i
                                              )
                                            ? "fa-regular fa-file-word"
                                            : uploadedFile.name.match(
                                                /\.(jpg|jpeg|png|gif)$/i
                                              )
                                            ? "fa-regular fa-file-image"
                                            : uploadedFile.name.match(
                                                /\.(xls|xlsx)$/i
                                              )
                                            ? "fa-regular fa-file-excel"
                                            : "fa-regular fa-file"
                                        } me-2`}
                                      />
                                    </div>
                                    <div className="card-body">
                                      <h6>
                                        <Link to="#">{uploadedFile?.name}</Link>
                                      </h6>
                                      <span>{fileSize || ""}</span>
                                    </div>
                                    <div className="card-footer">
                                      <span className="d-none d-sm-inline"></span>
                                      {lastModified || ""}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            <hr className="mt-4" />
                            {!uploadedFile && (
                              <>
                                <RecentFiles />
                                <h4>الملفات</h4>
                                <Files />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* /Page Content */}
      </div>
      <NotFreeModal
        modalId="notFreeModal"
        title="حفظ التقرير"
        content="الخدمة غير متاحة في النسخة المجانية  ! "
      />
      <NotFreeModal
        modalId="notFreeModal2"
        title="بحث متقدم "
        content="الخدمة غير متاحة في النسخة المجانية  ! "
      />

      <ReusableInfoModal
        modalId="fintrackAIInfo"
        title={fintracKModalData.title}
        sections={fintracKModalData.sections}
      />
    </>
  );
};

export default AiDataAnalysis;
